import { Component, OnInit } from '@angular/core';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { TextosService } from 'src/app/services/textos.service';
import { InventarioService } from 'src/app/services/inventario.service';
import { Ortopedicos } from 'src/app/models/Ortopedicos';

declare var $: any;


@Component({
  selector: 'app-listadodeaparatosortopedicos',
  templateUrl: './listadodeaparatosortopedicos.component.html',
  styleUrls: ['./listadodeaparatosortopedicos.component.css']
})
export class ListadodeaparatosortopedicosComponent implements OnInit {
 beneficiados: any[] = [];
  idortopedico: any =[];

ortopedicoinf: Ortopedicos ={
categoria:'',
numempleado:0, 
importe:0,
iva:0,
isr:0,
total:0,
no_factura:'',
fecha_factura:'',
beneficiado:'',
fecha_pago:'',
emisor:'',
esactivo: null,
idplantel:0,
periodo:0,
observacion: '',
no_oficio: '',
fecha_oficio:'',
quincena_pago:'',
folio_sat:''

}



  // Nombre del empleado principal seleccionado
  nombreEmpleadoSeleccionado: string = '';

  resetOrtopedicos() {
this.ortopedicoinf = {
categoria:'',
numempleado: null, 
importe:0,
iva:0,
isr:0,
total:0,
no_factura:'',
fecha_factura:'',
beneficiado:'',
fecha_pago:'',
emisor:'',
esactivo: null,
idplantel:0,
periodo:0,
observacion: '',
no_oficio: '',
fecha_oficio:'',
quincena_pago: ''
}
  this.nombreEmpleadoSeleccionado = '';

}
  // permisos
  DireccionGeneral = false;
  eliminaAsignatura = true;
  agregarAsignatura = true;
  editarAsignatura = true;

  datos = JSON.parse(localStorage.getItem('datos')!);
  mailusu = this.datos.correop;
  idplantel = this.datos.idplantel;
  idplantel1 = this.datos.idplantel;

  cargo: string;
  plantel: string;
  ortopedicoss: any = [];
  Nombre: string;
  infoplantel: any = [];
  empleado: any = [];
  periodoss: any = [];

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  ////////////////////////////////////
    archivo: File | null = null;
  xmllista: any = [];
  xmlPreview: any = {};  

  constructor(
    private inventarioService: InventarioService,
    private msj: mensajeSesionExpiradaService,
    private router: Router,
    private textosService: TextosService
  ) {
    this.cargo = this.datos.cargodb;
    this.plantel = this.datos.plantel;
    this.Nombre = this.datos.nom;
  }

  ngOnInit(): void {
       this.dtOptions = {
      pagingType: 'full_numbers',
      order: [[0, 'asc']],
      language: { url: 'https://cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json' }
    };
    this.getOrtopedicos();
    this.permisos();
    this.getEmpleado();
    this.getplantelinfo();
    this.getPeriodos();
  }

 getOrtopedicos() {
    this.inventarioService.getOrtopedicoslista().subscribe(
      res => { if (res == "TOKEN-EXPIRADO") { this.msj.tokenExpiradoCerrarSesion(); return; } this.ortopedicoss = res; this.dtTrigger.next(); },
      err => console.error(err)
    );
  }


formatearUUID() {
  let value = this.ortopedicoinf.folio_sat
    ?.toUpperCase()
    .replace(/[^A-Z0-9]/g, '') || '';

  if (value.length > 32) {
    value = value.substring(0, 32);
  }

  let formatted = '';
  if (value.length > 0) formatted += value.substring(0, 8);
  if (value.length > 8) formatted += '-' + value.substring(8, 12);
  if (value.length > 12) formatted += '-' + value.substring(12, 16);
  if (value.length > 16) formatted += '-' + value.substring(16, 20);
  if (value.length > 20) formatted += '-' + value.substring(20, 32);

  this.ortopedicoinf.folio_sat = formatted;
}



 actualizarNombreEmpleado() {
  const numEmp = String(this.ortopedicoinf.numempleado);
  
  // Busca al empleado seleccionado
  const empleadoSel = this.empleado.find(e => String(e.numpersonal) === numEmp);

  if (empleadoSel) {
    // Asigna el nombre completo
    this.nombreEmpleadoSeleccionado = `${empleadoSel.nombre} ${empleadoSel.appaterno} ${empleadoSel.apmaterno}`;
    this.ortopedicoinf.beneficiado = this.nombreEmpleadoSeleccionado;

    // Asigna automáticamente el idplantel correspondiente
    this.ortopedicoinf.idplantel = empleadoSel.idplantel;
        this.ortopedicoinf.categoria = empleadoSel.puesto ?? ''; 

  } else {
    this.nombreEmpleadoSeleccionado = '';
  
    this.ortopedicoinf.idplantel = null;
    this.ortopedicoinf.categoria = '';

  }
}



getPeriodos(){
       this.inventarioService.getPeriodoCatalogo().subscribe(
         res => {
   
           if(res=="TOKEN-EXPIRADO"){
             this.msj.tokenExpiradoCerrarSesion();   
             return;
         }
   
           this.periodoss = res;
   
         },
         err =>console.error(err)
       );
     }

  permisos() {
    if (["Auxiliar Direccion Academica","Control Escolar Plantel","Director de Plantel","Planes y Programas DG","Servicios Docentes DG","DG Sin Permisos"].includes(this.cargo)) {
      this.eliminaAsignatura = false;
      this.agregarAsignatura = false;
      this.editarAsignatura = false;
    }
  }

  getplantelinfo() {
    this.inventarioService.getPlantelCatalogo().subscribe(
      res => { if (res == "TOKEN-EXPIRADO") { this.msj.tokenExpiradoCerrarSesion(); return; } this.infoplantel = res; },
      err => console.error(err)
    );
  }

  getEmpleado() {
    this.inventarioService.getEmpleadoCatalogo().subscribe(
      res => { if (res == "TOKEN-EXPIRADO") { this.msj.tokenExpiradoCerrarSesion(); return; } this.empleado = res; console.log("Empleados:", this.empleado); },
      err => console.error(err)
    );
  }

guardarortopedico() {
  const mailusuario = this.mailusu;
  const noFactura = this.ortopedicoinf.no_factura?.trim().toUpperCase();

  // 🔹 VALIDAR que el No. de factura NO esté vacío
  if (!noFactura) {
    Swal.fire({
      title: 'Campo obligatorio',
      html: '<p style="text-align:center; color:#333;">Debe ingresar el número de factura antes de guardar.</p>',
      icon: 'warning',
      confirmButtonColor: '#720f3c'
    });
    return;
  }

  // 🔹 Buscar empleado seleccionado
  const empleadoSeleccionado = this.empleado.find(
    emp => String(emp.numpersonal) === String(this.ortopedicoinf.numempleado)
  );

  // 🔹 VALIDAR si es Directivo
  if (empleadoSeleccionado && empleadoSeleccionado.plaza?.toUpperCase().includes("DIRECTIV")) {
    Swal.fire({
      title: 'Registro no permitido',
      html: '<p style="text-align:center; color:#333;">No se puede registrar un apoyo de aparatos ortopédicos para personal <b>Directivo</b>.</p>',
      icon: 'error',
      confirmButtonColor: '#720f3c'
    });
    return;
  }

  // 🔹 CONSULTAR LISTA DE FACTURAS PARA VALIDAR DUPLICADOS
  this.inventarioService.getOrtopedicoslista().subscribe({
    next: (lentesExistentes: any[]) => {
      const facturaDuplicada = lentesExistentes.some(
        l => l.no_factura && l.no_factura.trim().toUpperCase() === noFactura
      );

      if (facturaDuplicada) {
        Swal.fire({
          title: 'Factura duplicada',
          html: '<p style="text-align:center; color:#333;">El número de factura que intenta registrar ya existe en el sistema.</p>',
          icon: 'error',
          confirmButtonColor: '#720f3c'
        });
        return;
      }

      // ✅ SOLO SI PASA LAS VALIDACIONES, GUARDAR
      this.inventarioService.createOrtopedicos(this.ortopedicoinf, mailusuario).subscribe({
        next: (res) => {
          if (res === "TOKEN-EXPIRADO") {
            this.msj.tokenExpiradoCerrarSesion();
            return;
          }

          Swal.fire({
            title: '¡Registrado correctamente!',
            html: '<p style="text-align:center; color:#333;">Se ha guardado correctamente el apoyo de aparatos ortopédicos.</p>',
            icon: 'success',
            confirmButtonColor: '#720f3c'
          });

          setTimeout(() => location.reload(), 1500);
        },
        error: (err) => {
          console.error('Error al guardar apoyo:', err);
          Swal.fire({
            title: 'Error',
            html: '<p style="text-align:center; color:#333;">Ocurrió un error al guardar el apoyo.</p>',
            icon: 'error',
            confirmButtonColor: '#720f3c'
          });
        }
      });
    },
    error: (err) => {
      console.error('Error al obtener lista de apoyos:', err);
      Swal.fire({
        title: 'Error',
        html: '<p style="text-align:center; color:#333;">No se pudo validar el número de factura.</p>',
        icon: 'error',
        confirmButtonColor: '#720f3c'
      });
    }
  });
}

pagarortopedicoss(id: any) {
  const mailuser = localStorage.getItem('mail');

  Swal.fire({
    title: '¿Se realizó el pago?',
    html: `<p style="text-align:center; color:#333;">Esta acción no se puede deshacer.</p>`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#720f3c',
    cancelButtonColor: '#606062',
    confirmButtonText: 'Sí, se pagó',
    cancelButtonText: 'No, queda pendiente',
    background: '#ffffff',
    allowOutsideClick: false
  }).then((result) => {

    // ================================
    // ✔ SI SE PAGÓ
    // ================================
    if (result.isConfirmed) {

      Swal.fire({
        title: 'Datos del pago',
        html: `
          <div style="display:flex; flex-direction:column; gap:12px; align-items:center; width:100%;">

            <input 
              type="date" 
              id="fechaPago" 
              class="swal2-input"
              style="width:85%; margin:0;"
            >

            <select 
              id="quincenaPago" 
              class="swal2-input"
              style="width:85%; margin:0;"
            >
              <option value="">Seleccione quincena</option>
              ${this.generarQuincenas()}
            </select>

          </div>
        `,
        showCancelButton: true,
        confirmButtonColor: '#720f3c',
        cancelButtonColor: '#606062',
        preConfirm: () => {
          const fecha = (document.getElementById('fechaPago') as HTMLInputElement).value;
          const quincena = (document.getElementById('quincenaPago') as HTMLSelectElement).value;

          if (!fecha || !quincena) {
            Swal.showValidationMessage('Debe ingresar fecha y quincena');
          }

          return { fecha, quincena };
        }
      }).then((r) => {

        if (!r.isConfirmed) return;

        this.inventarioService.pagarortopedico(
          id,
          r.value.fecha,
          r.value.quincena,
          1, // pagado = 1
          mailuser!
        ).subscribe({
          next: () => {
            Swal.fire({
              title: '¡Pago registrado!',
              icon: 'success',
              confirmButtonColor: '#720f3c'
            });
            setTimeout(() => location.reload(), 1400);
          },
          error: () => Swal.fire('Error', 'No se pudo actualizar', 'error')
        });

      });

    }

    // ================================
    // ❌ NO SE PAGÓ (PENDIENTE)
    // ================================
    else {

      Swal.fire({
        title: 'Quincena en que se pagará',
        html: `
          <div style="display:flex; flex-direction:column; gap:12px; align-items:center; width:100%;">

            <select 
              id="quincenaPendiente" 
              class="swal2-input"
              style="width:85%; margin:0;"
            >
              <option value="">Seleccione quincena</option>
              ${this.generarQuincenas()}
            </select>

          </div>
        `,
        showCancelButton: true,
        confirmButtonColor: '#720f3c',
        cancelButtonColor: '#606062',
        preConfirm: () => {
          const quincena = (document.getElementById('quincenaPendiente') as HTMLSelectElement).value;

          if (!quincena) {
            Swal.showValidationMessage('Debe elegir la quincena');
          }

          return quincena;
        }
      }).then((r) => {

        if (!r.isConfirmed) return;

        this.inventarioService.pagarortopedico(
          id,
          null,       // sin fecha
          r.value,    // quincena
          3,          // pagado = 3 -> pendiente
          mailuser!
        ).subscribe({
          next: () => {
            Swal.fire({
              title: 'Pago marcado como pendiente',
              icon: 'info',
              showConfirmButton: false

            });
            setTimeout(() => location.reload(), 1400);
          },
          error: () => Swal.fire('Error', 'No se pudo actualizar', 'error')
        });

      });

    }
  });
}




generarQuincenas() {
  const meses = [
    "ENERO","FEBRERO","MARZO","ABRIL","MAYO","JUNIO",
    "JULIO","AGOSTO","SEPTIEMBRE","OCTUBRE","NOVIEMBRE","DICIEMBRE"
  ];

  let html = "";
  meses.forEach(m => {
    html += `<option value="1A. QNA DE ${m}">1A. QNA DE ${m}</option>`;
    html += `<option value="2A. QNA DE ${m}">2A. QNA DE ${m}</option>`;
  });
  return html;
}


formatDate(date: string | Date) {
  const d = new Date(date);
  const month = ('0' + (d.getMonth() + 1)).slice(-2);
  const day = ('0' + d.getDate()).slice(-2);
  const year = d.getFullYear();
  return `${year}-${month}-${day}`;
}

calcularTotal() {
  if (!this.ortopedicoinf) return;

  const importe = Number(this.ortopedicoinf.importe) || 0;
  const iva = Number(this.ortopedicoinf.iva) || 0;
  const isr = Number(this.ortopedicoinf.isr) || 0;

  this.ortopedicoinf.total = parseFloat((importe - iva - isr).toFixed(2));
}

verortopedisss(idortopedico: any) {
  this.idortopedico = idortopedico;

  this.inventarioService.getortopedicoId(idortopedico).subscribe(
    (res: any) => {
      if (res === "TOKEN-EXPIRADO") {
        this.msj.tokenExpiradoCerrarSesion();
        return;
      }

      // Clonar objeto para evitar problemas de referencia
      this.ortopedicoinf = { ...res };

      console.log("Datos recibidos:", this.ortopedicoinf);

      // ✅ Convertir valores a número manteniendo valores si existen
      const numericFields = ['total', 'importe', 'iva', 'isr'];
      numericFields.forEach(field => {
        if (this.ortopedicoinf[field] !== null && this.ortopedicoinf[field] !== undefined) {
          this.ortopedicoinf[field] = Number(
            String(this.ortopedicoinf[field]).replace(/[$,]/g, '')
          );
        } else {
          this.ortopedicoinf[field] = 0;
        }
      });

      // ✅ Convertir fechas a formato yyyy-MM-dd
      const formatDate = (date: any) => {
        if (!date) return null;
        const d = new Date(date);
        return d.toISOString().substring(0, 10);
      };

      this.ortopedicoinf.fecha_factura = formatDate(this.ortopedicoinf.fecha_factura);
      this.ortopedicoinf.fecha_oficio = formatDate(this.ortopedicoinf.fecha_oficio);
      this.ortopedicoinf.fecha_pago = formatDate(this.ortopedicoinf.fecha_pago);

      this.actualizarNombreEmpleado();

      // ✅ Recalcular total al cargar
      this.calcularTotal();
    },
    err => console.error(err)
  );
}


// ✅ Cálculo funcional sin borrar valores al editar




eliminarortopedicos(id: any) {
  Swal.fire({
    title: '<i ></i><br>¿Desea eliminar el registro?',
    html: `
      <p style="text-align:center; color:#333; margin:10px 0;">
        Esta acción no se puede deshacer.
      </p>
    `,
    icon: 'warning',
    iconColor: '#c5ab5b',
    showCancelButton: true,
    confirmButtonColor: '#720f3c', // color vino
    cancelButtonColor: '#606062',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    background: '#ffffff',
    backdrop: 'rgba(0,0,0,0.3)',
    allowOutsideClick: false,
    customClass: {
      popup: 'animated-popup shadow-lg rounded-3'
    },
    showClass: {
      popup: 'animate__animated animate__fadeInDown'
    },
    hideClass: {
      popup: 'animate__animated animate__fadeOutUp'
    }
  }).then((result) => {
    if (result.isConfirmed) {
      // ✅ Elimina el registro si confirma
      this.inventarioService.deleteortopedicos(id).subscribe(
        res => {
          if (res === "TOKEN-EXPIRADO") {
            this.msj.tokenExpiradoCerrarSesion();
            return;
          }

          Swal.fire({
            title: '<i ></i><br>¡Registro eliminado!',
            html: `
              <p style="text-align:center; color:#333; margin:10px 0;">
                El registro se ha eliminado correctamente.
              </p>
            `,
            icon: 'success',
            iconColor: '#4CAF50',
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#720f3c',
            background: '#ffffff',
            backdrop: 'rgba(0,0,0,0.3)',
            allowOutsideClick: false,
            showConfirmButton: false,
            customClass: {
              popup: 'animated-popup shadow-lg rounded-3'
            },
            showClass: {
              popup: 'animate__animated animate__fadeInDown'
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp'
            }
          });

          // 🔄 Recargar después de 1.5 segundos
          setTimeout(() => {
            location.reload();
          }, 1500);
        },
        err => console.error(err)
      );

    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // ❌ Si cancela, cerrar el Swal
      Swal.close();

      // (Opcional) Mostrar mensaje de cancelación breve
      Swal.fire({
        title: '<i ></i><br>Acción cancelada',
        html: `
          <p style="text-align:center; color:#333; margin:10px 0;">
            No se realizaron cambios.
          </p>
        `,
        icon: 'info',
        iconColor: '#8f124d',
        showConfirmButton: false,
        timer: 1200,
        background: '#ffffff',
        backdrop: 'rgba(0,0,0,0.2)',
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      });
    }
  });
}

actualizarOrtopedicos() {
  // Validar que exista el ID de la beca
  if (!this.idortopedico) {
    Swal.fire('Error', 'No se encontró el ID del aparato ortopedico', 'error');
    return;
  }

  const mailusuario = this.mailusu;
  const id = this.idortopedico; // ← usamos el id guardado al abrir el modal

  this.inventarioService.updateOrtopedicos(id, this.ortopedicoinf, mailusuario).subscribe({
    next: (res: any) => {
      if(res === "TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();  
        return; 
      }

      Swal.fire({
        title: '¡Beca actualizada!',
        html: '<p style="text-align:center; color:#333;">Se ha actualizado correctamente el apoyo de aparato ortopedico.</p>',
        icon: 'success',
        confirmButtonColor: '#720f3c'
      });

      setTimeout(() => location.reload(), 1500);
    },
    error: (err) => {
      console.error(' Error al actualizar beca:', err);
      Swal.fire({
        title: 'Error',
        html: '<p style="text-align:center; color:#333;">No se pudo actualizar del aparato ortopedico.</p>',
        icon: 'error',
        confirmButtonColor: '#720f3c'
      });
    }
  });
}

///////////////////////////////////
abrirAgregarXML(id: number) {
  this.idortopedico = id;   // 🔑 GUARDAMOS LA BECA SELECCIONADA
  $('#Agrexml').modal('show');
}

  cerrarAgregarXML() {
  $('#Agrexml').modal('hide');

  // 🔄 Refresh después de 1.5 segundos
  setTimeout(() => {
    window.location.reload();
  }, 500);
}

  cerrarPreviewXML() {
  $('#previewXML').modal('hide');

  // 🔄 Refresh después de 1.5 segundos
  setTimeout(() => {
    window.location.reload();
  }, 1000);
}

  onFileSelected(event: any) {
    this.archivo = event.target.files[0];
    if (!this.archivo) return;

    const reader = new FileReader();

    reader.onload = () => {
      const xmlText = reader.result as string;

      // Parsear y extraer datos
      this.parseXML(xmlText);

     
      $('#Agrexml').modal('hide');

      setTimeout(() => {
        $('#previewXML').modal('show');
      }, 200); 
    };

    reader.readAsText(this.archivo);
  }

 parseXML(xmlString: string) {

  const parser = new DOMParser();
  const xml = parser.parseFromString(xmlString, "text/xml");

  const comprobante = xml.getElementsByTagName("cfdi:Comprobante")[0];
  const conceptos = xml.getElementsByTagName("cfdi:Concepto");
  const traslados = xml.getElementsByTagName("cfdi:Traslado");
  const retenciones = xml.getElementsByTagName("cfdi:Retencion");

  let subtotal = 0;
  let base16 = 0;
  let iva16 = 0;
  let base0 = 0;
  let impuestos = 0;
  let isr = 0;

  // 🔹 SUBTOTAL
  for (let i = 0; i < conceptos.length; i++) {
    subtotal += parseFloat(conceptos[i].getAttribute("Importe") || "0");
  }

  // 🔹 TRASLADOS (IVA)
  for (let i = 0; i < traslados.length; i++) {

    const tasa = traslados[i].getAttribute("TasaOCuota");
    const base = parseFloat(traslados[i].getAttribute("Base") || "0");
    const importe = parseFloat(traslados[i].getAttribute("Importe") || "0");

    impuestos += importe;

    if (tasa === "0.160000") {
      base16 += base;
      iva16 += importe;
    }

    if (tasa === "0.000000") {
      base0 += base;
    }
  }

  // 🔹 RETENCIONES (ISR)
  for (let i = 0; i < retenciones.length; i++) {

    const impuesto = retenciones[i].getAttribute("Impuesto");
    const importe = parseFloat(retenciones[i].getAttribute("Importe") || "0");

    if (impuesto === "001") { // ISR
      isr += importe;
    }
  }

  const totalXML = parseFloat(comprobante.getAttribute("Total") || "0");

  this.xmlPreview = {
    folio: comprobante.getAttribute("Folio") || '',
    subtotal: subtotal.toFixed(2),
    total: totalXML.toFixed(2),
    base16: base16.toFixed(2),
    iva16: iva16.toFixed(2),
    base0: base0.toFixed(2),
    impuestos: impuestos.toFixed(2),
    isr: isr.toFixed(2),
    rfc_emisor: this.extract(xmlString, /<cfdi:Emisor[^>]*Rfc="([^"]+)"/),
    nombre_emisor: this.extract(xmlString, /<cfdi:Emisor[^>]*Nombre="([^"]+)"/),
    rfc_receptor: this.extract(xmlString, /<cfdi:Receptor[^>]*Rfc="([^"]+)"/),
    nombre_receptor: this.extract(xmlString, /<cfdi:Receptor[^>]*Nombre="([^"]+)"/),
    uuid: this.extract(xmlString, /UUID="([^"]+)"/),
    no_certificado_sat: this.extract(xmlString, /NoCertificadoSAT="([^"]+)"/)
  };

}

  extract(xml: string, regex: RegExp) {
    const match = xml.match(regex);
    return match ? match[1] : '';
  }

confirmarXML() {

  if (!this.idortopedico) {
    Swal.fire('Error', 'No se encontró el apoyo seleccionado', 'error');
    return;
  }

  const payload = {
    ...this.xmlPreview,
    idortopedico: this.idortopedico   // 🔑 SE AGREGA
  };

  this.inventarioService.guardarXMLmanualortopedicos(payload).subscribe({
    next: () => {
      Swal.fire('XML guardado correctamente', '', 'success');
      this.cerrarPreviewXML();

      // 🔄 Refresh después de 1.5 segundos
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    },
    error: err => {
      Swal.fire(
        'Error',
        err.error?.message || 'Error al guardar el XML',
        'error'
      );
    }
  });
}
/////////////////
copiarTexto(texto: string) {
  if (!texto) return;

  navigator.clipboard.writeText(texto).then(() => {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: 'Copiado al portapapeles',
      showConfirmButton: false,
      timer: 1200,
      background: '#720f3c',
      color: '#fff'
    });
  });
}

irASAT() {
  window.open(
    'https://verificacfdi.facturaelectronica.sat.gob.mx/',
    '_blank'
  );
}
verXMLRegistrado(idortopedico: number) {
  this.inventarioService.getXMLOrtopedico(idortopedico)
    .subscribe((res: any) => {

      if (!res) {
        alert('No hay XML registrado.');
        return;
      }

      // cargar datos al preview
      this.xmlPreview = {
        folio: res.folio,
        subtotal: res.subtotal,
        total: res.total,
        rfc_emisor: res.rfc_emisor,
        nombre_emisor: res.nombre_emisor,
        rfc_receptor: res.rfc_receptor,
        nombre_receptor: res.nombre_receptor,
        uuid: res.uuid,
        no_certificado_sat: res.no_certificado_sat
      };

      // abrir modal
      ($('#previewXML') as any).modal('show');
    },
    err => console.error(err)
  );
}


verXMLsss(folio_sat: any) {

  this.inventarioService.getxmlOrtopId(folio_sat).subscribe(
    (res: any) => {

      if (res === "TOKEN-EXPIRADO") {
        this.msj.tokenExpiradoCerrarSesion();
        return;
      }

      console.log("XML recibido:", res);

      this.xmlPreview = res; // 👈 aquí

    },
    err => console.error(err)
  );
}



}
